import React, { Component } from 'react';
import './style.scss';
import { Tabs, Tab } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { I18n } from 'react-redux-i18n';
import * as color from '../../constant';
import { history } from '../../store';
import TimeslotsTab from './Components/TimeslotsTab';

// Espace de réglages global (page pleine page, pas une popup).
// Barre d'onglets horizontale en tête (sections de réglages), pensée pour
// accueillir de futurs réglages : chaque onglet reste self-contained.
const TABS = [
	{
		key: 'timeslots',
		label: 'settings.tabs.timeslots',
		render: () => <TimeslotsTab />,
	},
];

const styles = () => ({
	indicator: { backgroundColor: color.RED_ADDITION },
	selected: { color: color.RED_ADDITION },
});

class Settings extends Component {
	state = { tab: 0 };

	onChangeTab = (event, tab) => this.setState({ tab });

	render() {
		const { classes } = this.props;
		const { tab } = this.state;
		const current = TABS[tab];

		return (
			<div className="settings-page">
				<button
					type="button"
					className="settings-back"
					onClick={() => history.push('/partners')}>
					<ArrowBackIcon fontSize="small" />
					<span>{I18n.t('breadcrumb.partners')}</span>
				</button>
				<h1>{I18n.t('settings.title')}</h1>
				<div className="settings-body">
					<Tabs
						value={tab}
						onChange={this.onChangeTab}
						variant="scrollable"
						scrollButtons="auto"
						classes={{ indicator: classes.indicator }}
						className="settings-tabs">
						{TABS.map(t => (
							<Tab
								key={t.key}
								label={I18n.t(t.label)}
								classes={{ selected: classes.selected }}
							/>
						))}
					</Tabs>

					<div className="settings-tab-content">
						{current ? current.render() : null}
					</div>
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(Settings);
